import { useAppSelector } from '../../../core/utils';
import useAccessoriesData from '../../ConfigureBap/hooks/useAccessoriesData';
import { assetType, selectSelectedAssetType } from '../../../core/reducers/ui';
import useFetchLayoutServiceAssets from '../../../core/apiHooks/useFetchLayoutServiceAssets';
import usePlaceholderAssets from './usePlaceholderAssets';
import { getShouldRenderThreeSixty, getShowPlaceholder } from '../service/utils';
import { selectBodyTypesForGtm, selectCurrentVehicleFromVehicles } from '../../../core/reducers/vehicles';
const useGetTrimAssetsProps = (componentName, transmissionId, isInventoryVariant) => {
    var _a;
    const { exteriorColorKey, interiorColorKey } = useAppSelector(state => state.currentVehicle);
    const currentVehicle = useAppSelector(selectCurrentVehicleFromVehicles);
    const gtmBodyStyle = useAppSelector(selectBodyTypesForGtm);
    // assets for the currently selected exterior color
    const { data: colorAssets, isFetching, isLoading, } = useFetchLayoutServiceAssets({ transmissionId, exteriorColorKey, interiorColorKey });
    const { interiorImages, exteriorImages, threeSixtyInteriorImages, threeSixtyExteriorImages } = colorAssets;
    const { placeholderImage, isSuccessPlaceholder } = usePlaceholderAssets(transmissionId);
    const selectedType = useAppSelector(selectSelectedAssetType);
    const isExterior = selectedType === assetType.exterior;
    const carouselImages = isExterior ? exteriorImages : interiorImages;
    const { accessories } = useAccessoriesData();
    const accessoriesWithOverlayImages = (_a = accessories === null || accessories === void 0 ? void 0 : accessories.filter(accessory => accessory.isSelected && accessory.hasOverlayAssets)) === null || _a === void 0 ? void 0 : _a.map(accessory => ({
        id: accessory.id,
        overlayAssets: accessory.overlayAssets,
    }));
    const shouldRenderThreeSixty = getShouldRenderThreeSixty(isExterior, threeSixtyExteriorImages, threeSixtyInteriorImages);
    const showPlaceholder = getShowPlaceholder(isExterior, !!exteriorImages, !!threeSixtyExteriorImages, !!interiorImages, !!threeSixtyInteriorImages) && isSuccessPlaceholder;
    return {
        transmissionId,
        gtmVehicleData: {
            model: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.modelName,
            modelYear: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.modelYear,
            trim: currentVehicle === null || currentVehicle === void 0 ? void 0 : currentVehicle.trimName,
            componentType: componentName,
            gtmBodyStyle,
            isInventoryVariant,
            galleryType: isExterior ? assetType.exterior : assetType.interior,
        },
        placeholderImage,
        carouselImages,
        accessoriesWithOverlayImages,
        threeSixtyInteriorImages,
        threeSixtyExteriorImages,
        isFetching: isFetching || isLoading,
        showThreeSixty: shouldRenderThreeSixty,
        showPlaceholder,
        isExterior,
        isInventoryVariant,
    };
};
export default useGetTrimAssetsProps;
